export interface MovieReview {
  id: number;
  user: string;
  avatar: string;
  rating: number;
  date: string;
  content: string;
}

export interface Movie {
  id: number;
  title: string;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  duration: string;
  score: number;
  poster: string;
  backdrop?: string;
  tagline: string;
  excerpt: string;
  synopsis: string;
  featured: boolean;
  reviews: MovieReview[];
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "出轨的妻子",
    year: 2024,
    region: "国产",
    genres: ["剧情", "爱情", "悬疑"],
    director: "陈立川",
    cast: ["苏漫青", "林知远", "周慕白", "何嘉宁"],
    duration: "118 分钟",
    score: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20movie%20poster%20of%20an%20elegant%20woman%20in%20a%20dark%20formal%20dress%20looking%20away%20thoughtfully%20beside%20a%20rain%20streaked%20window%2C%20moody%20deep%20blue%20and%20warm%20amber%20lighting%2C%20emotional%20noir%20atmosphere%2C%20photorealistic%20editorial%20portrait&width=600&height=900&seq=poster-unfaithful-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20dramatic%20scene%20of%20a%20woman%20in%20a%20dark%20elegant%20dress%20standing%20alone%20by%20a%20large%20rain%20streaked%20window%20at%20dusk%2C%20deep%20blue%20shadows%20with%20warm%20amber%20lamp%20light%2C%20emotional%20noir%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20photorealistic%20cinematography&width=1920&height=1080&seq=backdrop-unfaithful-01&orientation=landscape",
    tagline: "每一段沉默里，都藏着一段没有说出口的往事。",
    excerpt: "当婚姻的裂缝被一次意外的相遇照亮，真相与谎言开始交替登场。",
    synopsis:
      "《出轨的妻子》以一场看似平静的周年纪念日为起点，讲述女主角苏漫青在婚姻表面的安稳之下，逐渐被一封匿名信卷入往事的漩涡。她开始怀疑丈夫的沉默、怀疑自己的记忆，也开始重新审视自己在这段关系中扮演的角色。影片用克制的镜头语言与层层递进的悬念，把「忠诚」「背叛」与「原谅」三个命题编织成一张细密的网。随着调查一步步深入，观众会发现，所谓的出轨或许只是表象，真正被隐藏的，是两个成年人各自不愿面对的孤独与遗憾。影片没有给出简单的道德裁决，而是把选择留给了角色，也留给了观众。",
    featured: true,
    reviews: [
      {
        id: 1,
        user: "深巷观影人",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20calm%20middle%20aged%20man%20with%20glasses%2C%20warm%20neutral%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-01&orientation=squarish",
        rating: 9,
        date: "2024-11-02",
        content:
          "整部片子最厉害的地方是它始终没有大声说话。所有的爆发都被压在一句轻描淡写的对白里，看完之后那种闷闷的钝痛感却久久散不掉。",
      },
      {
        id: 2,
        user: "午后的一杯茶",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20gentle%20young%20woman%20with%20short%20hair%2C%20soft%20warm%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-02&orientation=squarish",
        rating: 8,
        date: "2024-10-27",
        content:
          "女主的表演太细腻了，尤其是那种欲言又止的眼神。中段节奏稍慢，但结尾十分钟把前面所有的伏笔都还给了我，值回票价。",
      },
      {
        id: 3,
        user: "胶片收藏夹",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20young%20creative%20person%20with%20a%20cap%2C%20cool%20blue%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-03&orientation=squarish",
        rating: 9,
        date: "2024-10-20",
        content:
          "摄影和配乐都很高级，蓝色调的雨夜窗景几乎可以单拎出来当摄影展。它不是一部爽片，但绝对是一部值得二刷的片子。",
      },
    ],
  },
  {
    id: 2,
    title: "沉默的证词",
    year: 2023,
    region: "国产",
    genres: ["悬疑", "剧情"],
    director: "郑柏舟",
    cast: ["程野", "许安宁", "陆嘉明"],
    duration: "106 分钟",
    score: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Riveting%20crime%20thriller%20movie%20poster%20of%20a%20lone%20detective%20silhouette%20standing%20under%20a%20street%20lamp%20in%20misty%20rain%2C%20cold%20blue%20tones%20with%20subtle%20amber%20glow%2C%20tense%20film%20noir%20mood%2C%20photorealistic&width=600&height=900&seq=poster-silent-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20crime%20noir%20scene%20of%20an%20empty%20rainy%20city%20street%20at%20night%20with%20a%20lone%20detective%20figure%20walking%20away%2C%20wet%20reflective%20asphalt%2C%20cold%20blue%20tones%20with%20warm%20street%20lamp%20glow%2C%20moody%20atmospheric%20cinematography%2C%20photorealistic&width=1920&height=1080&seq=backdrop-silent-02&orientation=landscape",
    tagline: "有些证据需要时间才能开口。",
    excerpt: "一名老刑警重启尘封旧案，却发现沉默的证词指向了最不愿相信的人。",
    synopsis:
      "《沉默的证词》讲述一位即将退休的老刑警，在整理档案时偶然发现一桩十年前的悬案存在疑点。随着调查重启，当年所有沉默的证人都被重新唤醒，而真相却一步步指向他最信任的搭档。影片以冷静的叙事和扎实的细节推理，探讨了正义与情义之间的艰难抉择。",
    featured: true,
    reviews: [
      {
        id: 1,
        user: "夜行列车",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20serious%20man%20in%20a%20coat%2C%20cool%20blue%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-04&orientation=squarish",
        rating: 8,
        date: "2024-09-15",
        content: "推理线很稳，几乎每一步都能自洽。结尾那场对峙戏张力拉满。",
      },
    ],
  },
  {
    id: 3,
    title: "第二次告白",
    year: 2022,
    region: "日韩",
    genres: ["爱情", "剧情"],
    director: "金敏书",
    cast: ["韩素恩", "郑宰贤", "李恩惠"],
    duration: "112 分钟",
    score: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20movie%20poster%20of%20a%20young%20couple%20standing%20apart%20on%20a%20quiet%20autumn%20street%20lined%20with%20golden%20leaves%2C%20soft%20sunlight%20and%20gentle%20bokeh%2C%20tender%20melancholic%20tone%2C%20photorealistic%20editorial&width=600&height=900&seq=poster-confess-03&orientation=portrait",
    tagline: "喜欢这件事，说第二次永远比第一次更难。",
    excerpt: "错过的十年后，他们在一个雨天的便利店门口再次相遇。",
    synopsis:
      "《第二次告白》讲述一对大学时代的恋人因一场误会分开，十年后在城市角落重逢。影片用双线叙事交织过去与现在，细腻描绘两个人如何在时间的冲刷下重新认识彼此，也重新认识当年那个不够勇敢的自己。",
    featured: false,
    reviews: [
      {
        id: 1,
        user: "春日邮局",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20smiling%20young%20woman%2C%20soft%20pastel%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-05&orientation=squarish",
        rating: 9,
        date: "2024-08-08",
        content: "哭到隐形眼镜都掉了。那种错过感拍得太真实了。",
      },
    ],
  },
  {
    id: 4,
    title: "午夜列车",
    year: 2024,
    region: "欧美",
    genres: ["悬疑", "剧情"],
    director: "Elias Vaughn",
    cast: ["Marcus Reed", "Elena Fischer", "Tom Aldridge"],
    duration: "124 分钟",
    score: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Suspenseful%20movie%20poster%20of%20a%20solitary%20passenger%20sitting%20by%20a%20lit%20train%20window%20at%20night%2C%20raindrops%20on%20glass%2C%20cool%20teal%20and%20amber%20contrast%2C%20mysterious%20noir%20cinematic%20mood%2C%20photorealistic&width=600&height=900&seq=poster-midnight-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20from%20inside%20a%20moving%20night%20train%20carriage%2C%20empty%20seats%20with%20warm%20reading%20lights%2C%20rain%20streaked%20windows%20and%20passing%20city%20lights%2C%20cool%20teal%20and%20amber%20contrast%2C%20mysterious%20noir%20mood%2C%20photorealistic%20cinematography&width=1920&height=1080&seq=backdrop-midnight-04&orientation=landscape",
    tagline: "列车驶过午夜，没有人知道自己会在哪一站下车。",
    excerpt: "一列夜行列车上的六名乘客，各自带着一个不能说的秘密。",
    synopsis:
      "《午夜列车》是一部密室式的悬疑片。六名陌生乘客在一列夜行列车上被迫共处一夜，随着一名乘客的离奇失踪，所有人的秘密被逐一揭开。影片用紧张的空间调度和精巧的对话设计，把一座移动的车厢变成了人性的试炼场。",
    featured: true,
    reviews: [
      {
        id: 1,
        user: "午夜放映厅",
        avatar: "https://readdy.ai/api/search-image?query=Simple%20minimal%20flat%20avatar%20illustration%20of%20a%20man%20with%20a%20beard%2C%20dark%20cool%20tones%2C%20clean%20background&width=120&height=120&seq=avatar-06&orientation=squarish",
        rating: 8,
        date: "2024-10-05",
        content: "节奏快到不敢喘气，中后段的连续反转安排得很聪明。",
      },
    ],
  },
  {
    id: 5,
    title: "她与他之间",
    year: 2023,
    region: "日韩",
    genres: ["爱情", "剧情"],
    director: "佐藤绫",
    cast: ["小野遥", "高桥润", "中村葵"],
    duration: "98 分钟",
    score: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Delicate%20romantic%20drama%20movie%20poster%20of%20two%20figures%20nearly%20touching%20hands%20across%20a%20sunlit%20window%2C%20soft%20natural%20light%2C%20quiet%20intimate%20tone%2C%20muted%20warm%20color%20palette%2C%20photorealistic&width=600&height=900&seq=poster-between-05&orientation=portrait",
    tagline: "距离最近的时候，往往也是心最远的时候。",
    excerpt: "同居三年，他们却越来越像两个礼貌的陌生人。",
    synopsis:
      "《她与他之间》用极其日常的镜头，记录一对同居情侣在平淡生活中逐渐走远的全过程。没有激烈争吵，只有一次次被忽略的邀约、一顿顿沉默的晚餐。影片安静而锋利，探讨了亲密关系中那些无法言说的疏离。",
    featured: false,
    reviews: [],
  },
  {
    id: 6,
    title: "雾色迷城",
    year: 2021,
    region: "国产",
    genres: ["悬疑"],
    director: "罗志远",
    cast: ["江澈", "温雨晴", "方宇"],
    duration: "110 分钟",
    score: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20movie%20poster%20of%20a%20foggy%20city%20skyline%20with%20a%20lone%20figure%20walking%20through%20thick%20mist%2C%20muted%20grey%20blue%20with%20a%20faint%20amber%20streetlight%2C%20brooding%20cinematic%20mood%2C%20photorealistic&width=600&height=900&seq=poster-fogcity-06&orientation=portrait",
    tagline: "雾散了，可有些东西再也找不回来了。",
    excerpt: "一桩失踪案，牵出一座城市里被人刻意遗忘的角落。",
    synopsis:
      "《雾色迷城》以一桩普通的失踪案为引子，逐步揭开一座小城在时代变迁中被掩埋的往事。影片借雾气这一意象，隐喻记忆与真相的模糊边界，是一部兼具社会关怀与类型趣味的作品。",
    featured: false,
    reviews: [],
  },
  {
    id: 7,
    title: "失落的信",
    year: 2023,
    region: "欧美",
    genres: ["剧情"],
    director: "Clara Bennett",
    cast: ["Sophie Turner", "James Hale"],
    duration: "115 分钟",
    score: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20drama%20movie%20poster%20of%20scattered%20old%20letters%20and%20a%20vintage%20envelope%20on%20a%20wooden%20desk%20by%20a%20window%2C%20soft%20afternoon%20light%2C%20nostalgic%20warm%20neutral%20tones%2C%20photorealistic%20still%20life&width=600&height=900&seq=poster-lostletter-07&orientation=portrait",
    tagline: "有些话，寄出去用了三十年。",
    excerpt: "整理祖母遗物时，她发现了一箱从未寄出的信。",
    synopsis:
      "《失落的信》讲述一位年轻女性在整理祖母遗物时，发现了一整箱从未寄出的信件。循着信中的线索，她踏上一段跨越三代人的旅程，重新拼凑出一个家族被时间掩埋的故事。影片温润而深情。",
    featured: false,
    reviews: [],
  },
  {
    id: 8,
    title: "深蓝之下的秘密",
    year: 2024,
    region: "日韩",
    genres: ["悬疑", "剧情"],
    director: "朴叙镇",
    cast: ["崔诗妍", "姜道允", "尹恩彩"],
    duration: "121 分钟",
    score: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Stylish%20Korean%20mystery%20movie%20poster%20of%20a%20woman%20submerged%20to%20her%20shoulders%20in%20deep%20blue%20water%2C%20rippling%20surface%20reflections%2C%20moody%20teal%20and%20dark%20blue%20tones%2C%20serene%20yet%20unsettling%2C%20photorealistic&width=600&height=900&seq=poster-deepblue-08&orientation=portrait",
    tagline: "海面之下，藏着所有人都假装看不见的真相。",
    excerpt: "一名海洋生物学家的自杀，留下了一串谁也解不开的坐标。",
    synopsis:
      "《深蓝之下的秘密》围绕一名海洋生物学家的离奇身亡展开，她的妹妹在整理遗物时发现了一组神秘坐标。随着潜入越来越深的海域，一个关于研究机构与家族秘密的真相逐渐浮出水面。影片视觉冷冽，悬念层层递进。",
    featured: false,
    reviews: [],
  },
  {
    id: 9,
    title: "春日告白",
    year: 2022,
    region: "日韩",
    genres: ["爱情"],
    director: "长谷川透",
    cast: ["森田枫", "石井悠真"],
    duration: "102 分钟",
    score: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20romantic%20movie%20poster%20of%20a%20young%20couple%20cycling%20under%20cherry%20blossom%20trees%20in%20a%20sunny%20spring%20park%2C%20soft%20pink%20petals%20drifting%2C%20cheerful%20youthful%20tone%2C%20photorealistic&width=600&height=900&seq=poster-spring-09&orientation=portrait",
    tagline: "如果那年的春天再长一点，我大概就说出口了。",
    excerpt: "高中最后一个春天，她决定把三年的心事写进一封信。",
    synopsis:
      "《春日告白》是一部清新的青春爱情片，讲述一名高中女生在毕业前下定决心向暗恋三年的同学告白的故事。影片节奏轻快，充满春天般的气息，把青春里那份小心翼翼的喜欢拍得格外动人。",
    featured: false,
    reviews: [],
  },
  {
    id: 10,
    title: "无人知晓的夜晚",
    year: 2023,
    region: "国产",
    genres: ["剧情", "悬疑"],
    director: "沈知行",
    cast: ["唐亦", "白薇", "季航"],
    duration: "108 分钟",
    score: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20drama%20movie%20poster%20of%20an%20empty%20rainy%20city%20street%20at%20night%20with%20a%20distant%20lone%20figure%20and%20glowing%20shop%20signs%2C%20deep%20blue%20tones%20with%20warm%20amber%20highlights%2C%20lonely%20cinematic%20mood%2C%20photorealistic&width=600&height=900&seq=poster-unknownnight-10&orientation=portrait",
    tagline: "那一晚发生的事，只有他们两个人知道。",
    excerpt: "一场暴雨困住了三个人，也困住了一个必须被说出的秘密。",
    synopsis:
      "《无人知晓的夜晚》把故事压缩在一场暴雨之夜，三个人在一间便利店避雨，一夜之间，一个被隐瞒多年的秘密终于被摊开。影片以极简的场景和密集的对话，呈现了一场关于愧疚与勇气的深夜对话。",
    featured: false,
    reviews: [],
  },
  {
    id: 11,
    title: "边缘恋人",
    year: 2024,
    region: "欧美",
    genres: ["爱情", "剧情"],
    director: "Noah Sterling",
    cast: ["Isabella Cruz", "Daniel Frost"],
    duration: "119 分钟",
    score: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Intense%20romantic%20drama%20movie%20poster%20of%20a%20couple%20standing%20on%20a%20city%20rooftop%20at%20dusk%2C%20wind%20in%20their%20hair%2C%20warm%20orange%20sky%20fading%20into%20deep%20blue%2C%20passionate%20melancholic%20tone%2C%20photorealistic&width=600&height=900&seq=poster-edgelovers-11&orientation=portrait",
    tagline: "我们都在悬崖边上，却谁也没松手。",
    excerpt: "两个被生活逼到边缘的人，在一座城市里互相取暖。",
    synopsis:
      "《边缘恋人》讲述两个在城市边缘挣扎的年轻人因一次意外相遇，彼此成为对方黑暗生活里唯一的光。影片坦率而炽热，探讨了在困境中爱情究竟是救赎还是负担。",
    featured: false,
    reviews: [],
  },
  {
    id: 12,
    title: "回响",
    year: 2023,
    region: "国产",
    genres: ["悬疑", "剧情"],
    director: "岳清欢",
    cast: ["顾沉", "苏梨", "祝小满"],
    duration: "113 分钟",
    score: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20drama%20movie%20poster%20of%20a%20woman%20listening%20intently%20beside%20an%20old%20radio%20in%20a%20dim%20room%2C%20single%20warm%20lamp%20glow%2C%20deep%20blue%20shadows%2C%20suspenseful%20intimate%20mood%2C%20photorealistic&width=600&height=900&seq=poster-echo-12&orientation=portrait",
    tagline: "有些声音，会在很多年以后才回到你耳边。",
    excerpt: "一段被录音机偶然留下的对话，改变了一个家庭的命运。",
    synopsis:
      "《回响》的故事始于一段无意中录下的音频。多年以后，当这段声音重新被播放，一个家庭尘封的裂痕被彻底揭开。影片用声音作为叙事线索，营造出独特的悬疑氛围与情感张力。",
    featured: false,
    reviews: [],
  },
  {
    id: 13,
    title: "秋日情书",
    year: 2021,
    region: "日韩",
    genres: ["爱情", "剧情"],
    director: "尹智浩",
    cast: ["徐允儿", "权时厚"],
    duration: "105 分钟",
    score: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20romantic%20movie%20poster%20of%20a%20woman%20reading%20a%20letter%20on%20a%20bench%20in%20an%20autumn%20park%2C%20golden%20leaves%20falling%20around%20her%2C%20soft%20warm%20afternoon%20light%2C%20nostalgic%20serene%20tone%2C%20photorealistic&width=600&height=900&seq=poster-autumnletter-13&orientation=portrait",
    tagline: "那年秋天没寄出的情书，今年终于有了收信人。",
    excerpt: "整理旧书时，她翻出了一封写给自己的情书。",
    synopsis:
      "《秋日情书》讲述一位书店店员在整理旧书时，意外发现一封写给自己的情书。循着信中的记忆，她重新走回那段被自己刻意遗忘的青春秋日，也重新面对那个当年没有好好告别的自己。",
    featured: false,
    reviews: [],
  },
  {
    id: 14,
    title: "谎言与真相",
    year: 2024,
    region: "欧美",
    genres: ["悬疑", "剧情"],
    director: "Gregory Shaw",
    cast: ["Nathan Cole", "Mia Brooks", "Oliver Reed"],
    duration: "127 分钟",
    score: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Sharp%20crime%20thriller%20movie%20poster%20of%20a%20mans%20face%20half%20lit%20and%20half%20in%20deep%20shadow%2C%20split%20lighting%20in%20cool%20blue%20and%20warm%20amber%2C%20intense%20interrogation%20atmosphere%2C%20photorealistic&width=600&height=900&seq=poster-truthlies-14&orientation=portrait",
    tagline: "真相只有一个，但谎言可以有无数个版本。",
    excerpt: "一场庭审，让所有人都在陈述里藏了半句真话。",
    synopsis:
      "《谎言与真相》以一场备受瞩目的庭审为主线，通过不同证人的视角反复重构同一桩案件。影片结构精巧，像剥洋葱一样层层揭开每个人物隐瞒的动机，最终指向一个令人意外的答案。",
    featured: false,
    reviews: [],
  },
];